
		import workerPath from "omt:C:\\Users\\eight04\\dev\\closers-simulator\\src\\lib\\simulator.worker.mjs?comlink";
		import {wrap} from "comlink";

		export default wrap(new Worker(new URL(workerPath, import.meta.url)));
	